// extracted by mini-css-extract-plugin
export default {"flexContainer":"ChatEnd_flexContainer__3pYQP","chatEndContainer":"ChatEnd_chatEndContainer__WvbRa"};